import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearAllAction, screenLoadingAction } from 'redux/actions'
import { registerAndLogin } from 'redux/reducers/apiReducers/registerReducer'
import { logoutAction } from 'redux/reducers/apiReducers/authenticationReducer'
import axios from 'axios'
import moment from 'moment'
import BackAnchor from 'shared/components/BackAnchor'
import PrivacyStatement from './PrivacyStatement'

const ScreeningQuestionView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const [showPrivacyStatement, setShowPrivacyStatement] = useState(false)
  const dispatch = useDispatch()
  const [errMsg] = useState('')
  const [outageRichTexts, setOutageRichTexts] = useState([])
  const [outageStartDate, setOutageStartDate] = useState('')
  const [outageEndDate, setOutageEndDate] = useState('')
  const dateNow = moment().toDate()
  const outageUrl = window.location.origin + '/services/outageservice/api/outage-events'
  const [serviceFlag, setServiceFlag] = useState(false)
  const [dateFlag, setDateFlag] = useState(false)
  const [outageActive, setOutageActive] = useState(false)
  const [disableFlag, setDisableFlag] = useState(false)
  const [warningStartDate, setWarningStartDate] = useState('')
  const [warningEndDate, setWarningEndDate] = useState('')
  const [warningRichTexts, setWarningRichTexts] = useState([])
  const [warningFlag, setWarningFlag] = useState(false)
  const [warningActive, setWarningActive] = useState(false)
  const [warningServiceFlag, setWarningServiceFlag] = useState(false)
  const warnEventUrl = window.location.origin + '/services/outageservice/api/warning-events'

  const sendGetRequest = async () => {
    try {
      const res = await axios.get(outageUrl)
      const events = res.data
      const now = moment().toDate()
      const activeTexts = []
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYACOLLECTIONDEBT') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.outageStart).toDate()
        const endDate = moment(event.outageEnd).toDate()
        const isDateInRange = now > startDate && now < endDate
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          activeTexts.push(event.outageRichText)
          setOutageActive(true)
          setServiceFlag(true)
          setDateFlag(true)
          setDisableFlag(true)
        }
      }
      setOutageRichTexts(activeTexts)
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }

  const sendWarnGetRequest = async () => {
    try {
      const res = await axios.get(warnEventUrl)
      const events = res.data
      const now = moment().toDate()
      const activeWarnTexts = []
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYACOLLECTIONDEBT') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.warningStartDate).toDate()
        const endDate = moment(event.warningEndDate).toDate()
        const isDateInRange = now > startDate && now < endDate
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          activeWarnTexts.push(event.warningMessageText)
          setWarningActive(true)
          setWarningServiceFlag(true)
          setWarningFlag(true)
        }
      }
      setWarningRichTexts(activeWarnTexts)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    sendGetRequest()
    sendWarnGetRequest()
  }, [])

  useEffect(() => {
    try {
      dispatch(clearAllAction())
      dispatch(logoutAction()).catch((e) => {
        console.log(e)
      })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [dispatch, setIsError])

  const checkCookiesEnabled = () => {
    try {
      var cookieEnabled = navigator.cookieEnabled
      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
        if (cookieEnabled) {
          return true
        } else {
          setIsError('privacy_notice.enable_cookies')
        }
      }
      return cookieEnabled
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const yesNoClick = async (clickName) => {
    try {
      if (checkCookiesEnabled()) {
        dispatch(screenLoadingAction())
        dispatch(registerAndLogin())
          .then(() => {
            if (clickName === 'yes') {
              history.push(`/${i18n.language}${t('routes.screening_question_yes')}`)
            } else {
              history.push(`/${i18n.language}${t('routes.vehicle_tax_debt')}`)
            }
            dispatch(screenLoadingAction())
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setIsError('privacy_notice.server_error')
          })
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  function Banner() {
    if (disableFlag === true) {
      return (
        <>
          {outageRichTexts.map((text, index) => (
            <div
              key={index}
              className="alert-medium"
              data-gtm-vis-first-on-screen-9622674_25="908"
              data-gtm-vis-total-visible-time-9622674_25="100"
              data-gtm-vis-has-fired-9622674_25="1"
              data-gtm-vis-first-on-screen-9622674_29="912"
              data-gtm-vis-total-visible-time-9622674_29="100"
              data-gtm-vis-has-fired-9622674_29="1"
            >
              <p className="no-margin">
                <span>{text}</span>
              </p>
            </div>
          ))}
        </>
      )
    }
    return null
  }

  function WarningBanner() {
    if (warningFlag === true && disableFlag === false && warningServiceFlag === true && warningActive === true) {
      return (
        <>
          {warningRichTexts.map((text, index) => (
            <div
              key={index}
              className="alert-medium"
              data-gtm-vis-first-on-screen-9622674_25="908"
              data-gtm-vis-total-visible-time-9622674_25="100"
              data-gtm-vis-has-fired-9622674_25="1"
              data-gtm-vis-first-on-screen-9622674_29="912"
              data-gtm-vis-total-visible-time-9622674_29="100"
              data-gtm-vis-has-fired-9622674_29="1"
            >
              <p className="no-margin">
                <span>{text}</span>
              </p>
            </div>
          ))}
        </>
      )
    }
    return null
  }

  const togglePrivacyStatement = useCallback((e) => {
    e.preventDefault()
    setShowPrivacyStatement((prevState) => !prevState)
  }, [])

  const privacyToggleIcon = useMemo(() => (showPrivacyStatement ? 'fa-minus' : 'fa-plus'), [showPrivacyStatement])

  return (
    <div className="container">
      <main>
        <article className="col-md-8">
          <BackAnchor
            isInternal={false}
            backPath={
              i18n.language === 'en'
                ? 'https://beta.novascotia.ca/make-payment-your-collection-services-account'
                : 'https://beta.novascotia.ca/fr/faire-un-paiement-votre-compte-des-services-de-recouvrements'
            }
          />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('title')}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Banner />
              <WarningBanner />
              <h2>{t('screening_question.do_you_know')}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <h3>{t('screening_question.fines_processed_include')}</h3>
              <ul>
                <li>{t('screening_question.fines_you_owe')}</li>
                <li>{t('screening_question.summary_offence_tickets')}</li>
                <li>{t('screening_question.parking_tickets_processed')}</li>
                <li>{t('screening_question.criminal_code')}</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <button
                disabled={disableFlag}
                className="ns-btn-yes-no btn-default"
                style={{ marginRight: '20px' }}
                value={t('screening_question.yes')}
                name={t('screening_question.yes')}
                onClick={() => yesNoClick('yes')}
              >
                {' '}
                {t('screening_question.yes')}
              </button>
              <button
                disabled={disableFlag}
                className="ns-btn-yes-no btn-default"
                style={{ marginRight: '20px' }}
                value={t('screening_question.no')}
                name={t('screening_question.no')}
                onClick={() => yesNoClick('no')}
              >
                {' '}
                {t('screening_question.no')}
              </button>
            </div>
          </div>
        </article>
        <div className="row" style={{ marginBottom: '2rem' }}>
          <div className="col-xs-12 col-lg-8">
            <hr />
            <br />
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <i
                onClick={togglePrivacyStatement}
                aria-label={t('shared.error')}
                className="fa fa-lock fa-lg"
                aria-hidden="true"
                style={{ color: '#0058a4', marginTop: '3px' }}
              ></i>
              <a href="#" id="toggle-privacy-statement" onClick={togglePrivacyStatement}>
                {t('privacy_notice.how_we_protect_information')}
              </a>
              <i
                onClick={togglePrivacyStatement}
                aria-label={t('shared.error')}
                className={`fa fa-lg ${privacyToggleIcon}`}
                aria-hidden="true"
                style={{ color: '#0058a4', marginTop: '3px' }}
              ></i>
            </div>
            {showPrivacyStatement && <PrivacyStatement />}
            <br />
            <hr />
          </div>
        </div>
      </main>
    </div>
  )
}

export default withTranslation('common')(ScreeningQuestionView)
